module.exports = __webpack_public_path__ + "img/Zhangmen Brewery.2dc84804.svg";